import { app, authentication } from '@microsoft/teams-js';
import { useEffect, useState } from 'react';

export default function useTeamsApp() {
  const [teamsApp, setTeamsApp] = useState<{
    app: typeof app;
    authentication: typeof authentication;
  } | null>(null);
  useEffect(() => {
    app.initialize().then(() => {
      console.log('Teams app initialized');
      setTeamsApp({ app, authentication });
    }).catch(() => {
      setTeamsApp(null);
    });
  }, []);

  return teamsApp;
}
